module.exports = __webpack_public_path__ + "img/21_43.dd9ace1a.png";